module.exports = __webpack_public_path__ + "static/aggro-c9b53332ed2bc8c04197787d27911bf0.jpg";